import styled from '@emotion/styled';
import styles from './style.module.scss';
import {IconButton, SxProps} from '@mui/material';
import {ReactComponent as RestingStateIcon} from '../../assests/svg/lio_resting_badge.svg';
import {ReactComponent as RestingHoverStateIcon} from '../../assests/svg/lio_resting_hover_badge.svg';
import {ReactComponent as NotificationStateIcon} from '../../assests/svg/lio_notification_badge.svg';
import {ReactComponent as NotificationHoverStateIcon} from '../../assests/svg/lio_notification_hover_badge.svg';
import {ReactComponent as ActiveStateIcon} from '../../assests/svg/lio_active_badge.svg';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {setEntityAndtask} from '../../redux/slices/askLioSlice';
import {removeLeadingSlash} from '../../utils/utils';
import {t} from 'i18next';

const StyledButton = styled(IconButton)({});

type AskLioProps = {
  variant?: 'resting' | 'notification' | 'active';
  position?:
    | 'topLeft'
    | 'bottomLeft'
    | 'topRight'
    | 'bottomRight'
    | 'fixed'
    | 'current';
  ariaLabel?: string;
  className?: string;
  role?: string;
  sx?: SxProps;
  onClick?: () => void;
};

const AurAskLioButton: React.FC<AskLioProps> = ({
  variant = 'resting',
  position = 'bottomLeft',
  ariaLabel = t('askLio.askLioAriaLabel'),
  role = 'button',
  className,
  sx,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    let entity = removeLeadingSlash(location.pathname);
    entity = encodeURIComponent(entity).replace(/\//g, '%2F');

    dispatch(
      setEntityAndtask({
        entity: entity,
        task: 'view',
      })
    );
  }, [dispatch, location.pathname]);

  const renderIcon = () => {
    if (variant === 'resting') {
      return isHovered ? <RestingHoverStateIcon aria-hidden="true" /> : <RestingStateIcon aria-hidden="true" />;
    }
    if (variant === 'notification') {
      return isHovered ? (
        <NotificationHoverStateIcon aria-hidden="true" />
      ) : (
        <NotificationStateIcon aria-hidden="true" />
      );
    }
    if (variant === 'active') {
      return <ActiveStateIcon aria-hidden="true" />;
    }

    return <RestingStateIcon aria-hidden="true" />;
  };

  const lioPosition = (): string => {
    switch (position) {
      case 'topLeft':
        return styles.aurPositionTopLeft;
      case 'bottomLeft':
        return styles.aurPositionBottomLeft;
      case 'topRight':
        return styles.aurPositionTopRight;
      case 'bottomRight':
        return styles.aurPositionBottomRight;
      default:
        return styles.aurPositionFixed;
    }
  };

  return (
    <>
      <StyledButton
        aria-label={ariaLabel}
        className={`${styles.aurAskLioButton} ${lioPosition()} ${className}`}
        sx={sx}
        role={role}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {renderIcon()}
      </StyledButton>
    </>
  );
};

export default AurAskLioButton;
